import { ReactNode } from 'react'

import styles from './CockpitTable.module.scss'

interface ICockpitTableProps<T> {
  columns: ICockpitTableColumn<T>[]
  items: T[]
  getItemKey: (item: T) => string | number
}

export interface ICockpitTableColumn<T> {
  key: string
  header: ReactNode
  renderCell: (item: T) => ReactNode
}

export const CockpitTable = <T,>({ columns, items, getItemKey }: ICockpitTableProps<T>) => (
  <div className={styles.tableWrap}>
    <table className={styles.table}>
      <thead>
        <tr>
          {columns.map(({ key, header }) => (
            <th key={key}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <tr key={getItemKey(item)}>
            {columns.map(({ key, renderCell }) => (
              <td key={key}>{renderCell(item)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

CockpitTable.displayName = 'CockpitTable'
